export enum OrganizationLevelType {
  ROOT = 'ROOT',
  REGION = 'REGION',
  DISTRICT = 'DISTRICT',
  ORGANIZATION = 'ORGANIZATION',
  STRUCTURAL_DIVISION = 'STRUCTURAL_DIVISION',
  FACILITY = 'FACILITY', // нужен только для меню
}

export enum OrganizationStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
}

export const OrganizationStatusLabel: Record<OrganizationStatus, string> = {
  [OrganizationStatus.ACTIVE]: 'Активна',
  [OrganizationStatus.BLOCKED]: 'Заблокирована',
  [OrganizationStatus.DELETED]: 'Удалена',
};
